var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('span',[(_vm.br)?_c('br'):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" "+_vm._s(_vm.quantify(_vm.name, _vm.cost, 0, 0, _vm.formatCost))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }